import { catchError, flatMap, switchMap } from "rxjs/operators"
import { combineEpics, ofType } from "redux-observable"
import { from, of, EMPTY } from "rxjs"
import { Epic } from "../../../../epics"

import * as actions from "./actions"

export const requestHomePageUrlEpic: Epic = (
    action$,
    _state$,
    { userMenu: { userMenuAPI } },
) =>
    action$.pipe(
        ofType(actions.REQUEST_HOME_PAGE_URL),
        switchMap(() => {
            return from(userMenuAPI.getHomePage()).pipe(
                flatMap((url: string) => of(actions.receiveHomePageUrl(url))),
                catchError((error) => {
                    console.error(error)
                    return EMPTY
                }),
            )
        }),
    )

export default combineEpics(requestHomePageUrlEpic)
